import React, { useEffect, useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function Pricing() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  const [selectedPlan, setSelectedPlan] = useState<'basic' | 'pro'>('pro');
  const [timeLeft, setTimeLeft] = useState({
    h: 23,
    m: 24,
    s: 44
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          h,
          m,
          s
        } = prev;
        if (s > 0) s--;else {
          s = 59;
          if (m > 0) m--;else {
            m = 59;
            if (h > 0) h--;
          }
        }
        return {
          h,
          m,
          s
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (val: number) => val.toString().padStart(2, '0');
  return <section id="pricing" className="py-12 bg-surface border-t border-white/5 relative overflow-hidden" aria-label="Precios y planes" data-id="element-267">
      <div className="container mx-auto px-4 max-w-6xl relative z-10" data-id="element-268">
        <FadeIn data-id="element-269">
          <div className="text-center mb-8" data-id="element-270">
            <h3 className="text-xl md:text-2xl font-bold text-white mb-4" data-id="element-271">
              ⏰ PRECIO DE LANZAMIENTO — CIERRA EN:
            </h3>
            <div className="flex items-center justify-center gap-2 md:gap-4 text-3xl md:text-5xl font-heading font-bold text-gold" data-id="element-272">
              <div className="bg-surfaceLight border border-white/10 rounded-xl px-4 py-3 min-w-[80px]" data-id="element-273">
                {formatTime(timeLeft.h)}
                <span className="text-sm block text-gray-400 font-body font-normal mt-1" data-id="element-274">
                  hs
                </span>
              </div>
              <span className="text-gray-500 pb-6" data-id="element-275">:</span>
              <div className="bg-surfaceLight border border-white/10 rounded-xl px-4 py-3 min-w-[80px]" data-id="element-276">
                {formatTime(timeLeft.m)}
                <span className="text-sm block text-gray-400 font-body font-normal mt-1" data-id="element-277">
                  min
                </span>
              </div>
              <span className="text-gray-500 pb-6" data-id="element-278">:</span>
              <div className="bg-surfaceLight border border-white/10 rounded-xl px-4 py-3 min-w-[80px]" data-id="element-279">
                {formatTime(timeLeft.s)}
                <span className="text-sm block text-gray-400 font-body font-normal mt-1" data-id="element-280">
                  seg
                </span>
              </div>
            </div>
            <p className="text-red-400 mt-4 font-medium" data-id="element-281">
              ⚠️ Después sube $8.000 ARS. No vuelve.
            </p>
          </div>
        </FadeIn>

        <FadeIn data-id="element-282">
          <h2 className="text-3xl md:text-4xl font-bold text-white text-center mb-8" data-id="element-283">
            ELEGÍ TU <span className="text-gold" data-id="element-284">PACK</span>
          </h2>
        </FadeIn>

        <div id="elegir-plan" className="max-w-2xl mx-auto mb-12" role="radiogroup" aria-label="Seleccionar plan" data-id="element-285">
          <FadeIn delay={0.05} data-id="element-286">
            <div className="mb-6" data-id="element-287">
              <div className="flex justify-between text-sm mb-2" data-id="element-288">
                <span className="text-red-400 font-bold flex items-center gap-2" data-id="element-289">
                  <span className="w-2 h-2 rounded-full bg-red-500 animate-pulse" data-id="element-290"></span>
                  Cupos al precio de lanzamiento — Quedan pocos
                </span>
                <span className="text-gray-400" data-id="element-291">68%</span>
              </div>
              <div className="w-full bg-surfaceLight rounded-full h-2.5 overflow-hidden border border-white/5" data-id="element-292">
                <div className="bg-gold h-2.5 rounded-full" style={{
                width: '68%'
              }} data-id="element-293"></div>
              </div>
              <p className="text-xs text-gray-500 mt-2 text-center" data-id="element-294">
                68% de los cupos al precio de lanzamiento ya tomados
              </p>
            </div>
          </FadeIn>

          {/* Pack 1 — Basic */}
          <FadeIn delay={0.1} data-id="element-295">
            <button onClick={() => setSelectedPlan('basic')} role="radio" aria-checked={selectedPlan === 'basic'} aria-label="El Maestro de las Mamparas — Sistema Completo — $19.990 ARS" className={`w-full text-left rounded-2xl p-6 mb-4 transition-all duration-300 border-2 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold ${selectedPlan === 'basic' ? 'border-gold shadow-[0_0_25px_rgba(245,200,66,0.15)] bg-surfaceLight/60' : 'border-white/10 bg-background hover:border-white/20'}`} data-id="element-296">
              <div className="flex items-start gap-4" data-id="element-297">
                <div className={`mt-1 w-5 h-5 rounded-full border-2 flex items-center justify-center shrink-0 transition-colors ${selectedPlan === 'basic' ? 'border-gold' : 'border-gray-500'}`} data-id="element-298">
                  {selectedPlan === 'basic' && <div className="w-2.5 h-2.5 rounded-full bg-gold" data-id="element-299"></div>}
                </div>

                <div className="flex-1 min-w-0" data-id="element-300">
                  <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4" data-id="element-301">
                    <div data-id="element-302">
                      <h3 className="text-lg font-bold text-white flex items-center gap-2 mb-1" data-id="element-303">
                        <span data-id="element-304">📘</span> EL MAESTRO DE LAS MAMPARAS — SISTEMA
                        COMPLETO
                      </h3>
                      <p className="text-gray-400 text-xs mb-3" data-id="element-305">
                        Para empezar con sistema · 8 Módulos + 3 Bonos
                      </p>
                      <div className="bg-surfaceLight/50 px-3 py-2 rounded-lg border border-white/5 text-xs text-gray-300 inline-block" data-id="element-306">
                        <span className="font-semibold text-white" data-id="element-307">
                          Ideal para:
                        </span>{' '}
                        Carpinteros e instaladores que quieren dejar de
                        improvisar y trabajar con sistema desde hoy
                      </div>
                    </div>
                    <div className="sm:text-right shrink-0" data-id="element-308">
                      <span aria-hidden="true" className="text-gray-500 line-through text-sm block" data-id="element-309">
                        $45.000
                      </span>
                      <span className="text-2xl font-bold text-white font-heading" data-id="element-310">
                        $19.990
                      </span>
                      <span className="text-sm text-gray-400 ml-1" data-id="element-311">ARS</span>
                    </div>
                  </div>
                </div>
              </div>
            </button>
          </FadeIn>

          {/* Pack 2 — Pro (dominant) */}
          <FadeIn delay={0.2} data-id="element-312">
            <div id="pack-pro" className="relative my-6 scroll-mt-24" data-id="element-313">
              <div className="absolute -inset-0.5 rounded-3xl opacity-60 blur-md pointer-events-none" aria-hidden="true" style={{
              background: 'linear-gradient(135deg, rgba(245,200,66,0.6) 0%, rgba(212,168,67,0.4) 100%)'
            }} data-id="element-314"></div>
              <div className="absolute -top-3 left-1/2 -translate-x-1/2 z-10" data-id="element-315">
                <span className="bg-gold text-background font-bold px-5 py-1.5 rounded-full text-xs uppercase tracking-wider whitespace-nowrap shadow-lg" data-id="element-316">
                  ⭐ El más elegido — Taller profesional completo
                </span>
              </div>
              <button onClick={() => setSelectedPlan('pro')} role="radio" aria-checked={selectedPlan === 'pro'} aria-label="Pack Maestro Pro — Todo Incluido — $29.990 ARS" className={`relative w-full text-left rounded-3xl p-7 md:p-8 transition-all duration-300 border-2 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold ${selectedPlan === 'pro' ? 'border-gold shadow-[0_0_35px_rgba(245,200,66,0.25)] bg-surfaceLight/80' : 'border-gold/40 bg-surfaceLight/50 hover:border-gold/70'}`} data-id="element-317">
                <div className="flex items-start gap-4" data-id="element-318">
                  <div className={`mt-1 w-5 h-5 rounded-full border-2 flex items-center justify-center shrink-0 transition-colors ${selectedPlan === 'pro' ? 'border-gold' : 'border-gray-500'}`} data-id="element-319">
                    {selectedPlan === 'pro' && <div className="w-2.5 h-2.5 rounded-full bg-gold" data-id="element-320"></div>}
                  </div>

                  <div className="flex-1 min-w-0" data-id="element-321">
                    <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4" data-id="element-322">
                      <div data-id="element-323">
                        <h3 className="text-xl md:text-2xl font-bold text-white flex items-center gap-2 mb-1" data-id="element-324">
                          <span data-id="element-325">🏆</span> PACK MAESTRO PRO — TODO INCLUIDO
                        </h3>
                        <p className="text-gold text-sm md:text-base font-medium mb-3" data-id="element-326">
                          8 Módulos + 3 Bonos + Pack Maestro Pro + 7 Planillas
                          Pro
                        </p>
                        <div className="bg-gold/10 px-3 py-2 rounded-lg border border-gold/30 text-xs text-gray-200 inline-block" data-id="element-327">
                          <span className="font-semibold text-white" data-id="element-328">
                            Ideal para:
                          </span>{' '}
                          Talleres que quieren calcular, presupuestar y
                          gestionar trabajos sin errores y sin calculadora
                        </div>
                      </div>
                      <div className="sm:text-right shrink-0" data-id="element-329">
                        <span aria-hidden="true" className="text-gray-500 line-through text-sm block" data-id="element-330">
                          $57.000
                        </span>
                        <span className="text-4xl md:text-5xl font-bold text-gold font-heading" data-id="element-331">
                          $29.990
                        </span>
                        <span className="text-sm text-gold/70 ml-1" data-id="element-332">ARS</span>
                      </div>
                    </div>
                  </div>
                </div>
              </button>
            </div>
          </FadeIn>

          <FadeIn delay={0.4} data-id="element-333">
            <a id="cta-comprar" href={selectedPlan === 'pro' ? 'https://fegion.shop/cart/46934190555275:1' : 'https://fegion.shop/cart/46850728263819:1'} className={`block w-full mt-6 py-5 text-center rounded-2xl font-bold transition-colors shadow-lg uppercase tracking-wider text-lg focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold bg-gold hover:bg-gold/90 text-background shadow-[0_0_25px_rgba(245,200,66,0.35)]`} data-id="element-334">
              {selectedPlan === 'pro' ? '→ QUIERO EL PACK MAESTRO PRO COMPLETO' : '→ QUIERO MI SISTEMA MAESTRO AHORA'}
            </a>
          </FadeIn>

          <FadeIn delay={0.45} data-id="element-335">
            <div className="mt-4 flex flex-wrap justify-center items-center gap-x-6 gap-y-2 text-sm text-gray-300" data-id="element-336">
              <div className="flex items-center gap-2" data-id="element-337">
                <span className="text-emerald-400" aria-hidden="true" data-id="element-338">
                  🛡️
                </span>
                <span data-id="element-339">Garantía 7 días</span>
              </div>
              <span className="text-white/20" aria-hidden="true" data-id="element-340">
                ·
              </span>
              <div className="flex items-center gap-2" data-id="element-341">
                <span className="text-emerald-400" aria-hidden="true" data-id="element-342">
                  ⚡
                </span>
                <span data-id="element-343">Acceso de inmediato</span>
              </div>
              <span className="text-white/20" aria-hidden="true" data-id="element-344">
                ·
              </span>
              <div className="flex items-center gap-2" data-id="element-345">
                <span className="text-emerald-400" aria-hidden="true" data-id="element-346">
                  🔒
                </span>
                <span data-id="element-347">Pago 100% seguro</span>
              </div>
            </div>
          </FadeIn>
        </div>

        {/* Comparison table */}
        <FadeIn delay={0.2} data-id="element-348"></FadeIn>

        {/* Includes */}
        <FadeIn delay={0.3} data-id="element-349">
          <div className="max-w-5xl mx-auto mb-12" data-id="element-350">
            <h3 className="text-2xl md:text-3xl font-bold text-white mb-2 text-center" data-id="element-351">
              ✅ ¿QUÉ INCLUYE CADA UNO?
            </h3>
            <p className="text-gray-400 text-center mb-8" data-id="element-352">
              Todo lo que entra dentro de cada componente
            </p>

            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6" data-id="element-353">
              {/* Base */}
              <div className="bg-surfaceLight/30 rounded-2xl p-6 md:p-7 border border-white/10" data-id="element-354">
                <div className="flex items-center gap-3 mb-5 pb-4 border-b border-white/10" data-id="element-355">
                  <span className="text-3xl" aria-hidden="true" data-id="element-356">
                    📘
                  </span>
                  <div data-id="element-357">
                    <h4 className="text-base md:text-lg font-bold text-white leading-tight" data-id="element-358">
                      EL MAESTRO DE LAS MAMPARAS
                    </h4>
                    <p className="text-xs text-gray-400" data-id="element-359">
                      Incluido en ambos packs
                    </p>
                  </div>
                </div>
                <ul className="space-y-2.5" data-id="element-360">
                  {['8 Módulos completos (220+ páginas)', 'Bono 1 — Kit Express de Respuestas para Cerrar por WhatsApp', 'Bono 2 — Checklist Maestro de Visita y Cierre en Obra', 'Bono 3 — Guía Rápida de Limpieza, Cuidado y Entrega al Cliente'].map((item, i) => <li key={i} className="flex items-start gap-2.5 text-sm text-gray-200" data-id="element-361">
                      <span className="text-emerald-400 mt-0.5 shrink-0" aria-hidden="true" data-id="element-362">
                        ✓
                      </span>
                      <span data-id="element-363">{item}</span>
                    </li>)}
                </ul>
              </div>

              {/* Pack Maestro Pro */}
              <div className="bg-surfaceLight/30 rounded-2xl p-6 md:p-7 border border-gold/30" data-id="element-364">
                <div className="flex items-center gap-3 mb-5 pb-4 border-b border-gold/20" data-id="element-365">
                  <span className="text-3xl" aria-hidden="true" data-id="element-366">
                    🛡️
                  </span>
                  <div data-id="element-367">
                    <h4 className="text-base md:text-lg font-bold text-gold leading-tight" data-id="element-368">
                      PACK MAESTRO PRO
                    </h4>
                    <p className="text-xs text-gray-400" data-id="element-369">
                      Incluido solo en el Pack Maestro Pro
                    </p>
                  </div>
                </div>
                <ul className="space-y-2.5" data-id="element-370">
                  {['🛡️ Blindaje Anti-Error — Fórmulas exactas de corte y alertas visuales para no perder cristales', '💰 Calculadora de Rentabilidad — Costos ocultos, precio real y scripts para defender tu precio', '📄 Kit Legal Profesional — Contrato de señado, certificado de garantía y modelo de presupuesto'].map((item, i) => <li key={i} className="flex items-start gap-2.5 text-sm text-gray-200" data-id="element-371">
                      <span className="text-gold mt-0.5 shrink-0" aria-hidden="true" data-id="element-372">
                        ✓
                      </span>
                      <span data-id="element-373">{item}</span>
                    </li>)}
                </ul>
              </div>

              {/* 7 Planillas Pro */}
              <div className="bg-surfaceLight/30 rounded-2xl p-6 md:p-7 border border-gold/30" data-id="element-374">
                <div className="flex items-center gap-3 mb-5 pb-4 border-b border-gold/20" data-id="element-375">
                  <span className="text-3xl" aria-hidden="true" data-id="element-376">
                    🏆
                  </span>
                  <div data-id="element-377">
                    <h4 className="text-base md:text-lg font-bold text-gold leading-tight" data-id="element-378">
                      7 PLANILLAS PRO
                    </h4>
                    <p className="text-xs text-gray-400" data-id="element-379">
                      Incluido solo en el Pack Maestro Pro
                    </p>
                  </div>
                </div>
                <ul className="space-y-2.5" data-id="element-380">
                  {['Calculadora de Descuentos de Cristal', 'Calculadora de Presupuesto Completo', 'Planilla de Relevamiento en Obra', 'Control de Stock de Materiales', 'Seguimiento de Trabajos Activos', 'Calculadora de Rentabilidad por Trabajo', 'Registro de Clientes y Postventa'].map((item, i) => <li key={i} className="flex items-start gap-2.5 text-sm text-gray-200" data-id="element-381">
                      <span className="text-gold mt-0.5 shrink-0" aria-hidden="true" data-id="element-382">
                        ✓
                      </span>
                      <span data-id="element-383">{item}</span>
                    </li>)}
                </ul>
              </div>
            </div>
          </div>
        </FadeIn>

        {/* Testimonials */}
        <FadeIn delay={0.4} data-id="element-384">
          <div className="max-w-5xl mx-auto mb-12" data-id="element-385">
            <h3 className="text-2xl md:text-3xl font-bold text-white mb-10 text-center" data-id="element-386">
              ❤️ MÁS TALLERES QUE YA LO TIENEN
            </h3>
            <div className="grid md:grid-cols-3 gap-6" data-id="element-387">
              {[{
              name: 'Jorge R.',
              loc: '📍 Córdoba',
              plan: 'Sistema completo',
              text: 'Pegué las fórmulas en el taller y mi ayudante midió y pidió el cristal solo. No me llamó una sola vez para preguntar.'
            }, {
              name: 'Marcelo P.',
              loc: '📍 Rosario',
              plan: 'Instalador de Mamparas',
              text: 'El Módulo 6 de instalación me eliminó las filtraciones. No tuve un solo reclamo en los últimos 3 meses.'
            }, {
              name: 'Carlos A.',
              loc: '📍 Buenos Aires',
              plan: 'Carpintero independiente',
              text: 'Con el Módulo 8 me di cuenta que en algunos trabajos estaba perdiendo plata. Ahora presupuesto con margen real.'
            }].map((t, i) => <div key={i} className="bg-surfaceLight p-6 rounded-2xl border border-white/5" data-id="element-388">
                  <div className="flex gap-1 mb-3" data-id="element-389">
                    {[...Array(5)].map((_, j) => <span key={j} className="text-gold text-sm" data-id="element-390">
                        ★
                      </span>)}
                  </div>
                  <p className="text-gray-300 mb-4 italic" data-id="element-391">"{t.text}"</p>
                  <div className="text-sm" data-id="element-392">
                    <span className="font-bold text-white" data-id="element-393">{t.name}</span>
                    <span className="text-gray-500 mx-2" data-id="element-394">|</span>
                    <span className="text-gray-400" data-id="element-395">{t.loc}</span>
                    <span className="text-gray-500 mx-2" data-id="element-396">|</span>
                    <span className="text-gold text-xs" data-id="element-397">{t.plan}</span>
                  </div>
                </div>)}
            </div>
          </div>
        </FadeIn>

        {/* Guarantee */}
        <FadeIn delay={0.5} data-id="element-398">
          <div className="max-w-3xl mx-auto bg-surfaceLight/50 rounded-3xl p-8 md:p-12 border border-white/5 text-center" data-id="element-399">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-white/5 mb-6 text-4xl" data-id="element-400">
              🛡️
            </div>
            <h3 className="text-2xl md:text-3xl font-bold text-white mb-4" data-id="element-401">
              GARANTÍA 7 DÍAS — SIN PREGUNTAS
            </h3>
            <p className="text-gray-300 text-lg mb-6" data-id="element-402">
              Abrís los módulos. Los usás en el taller y en la obra. Si en 7
              días no es lo que esperabas:
            </p>
            <div className="flex flex-col sm:flex-row justify-center gap-4 mb-6 text-white font-medium" data-id="element-403">
              <div className="flex items-center justify-center gap-2" data-id="element-404">
                <span className="text-emerald-400" data-id="element-405">✅</span> devolución del 100%
              </div>
              <div className="flex items-center justify-center gap-2" data-id="element-406">
                <span className="text-emerald-400" data-id="element-407">✅</span> sin formularios,
                sin drama.
              </div>
            </div>
            <div className="inline-block bg-background px-4 py-2 rounded-lg border border-white/10 text-sm text-gray-400" data-id="element-408">
              Tasa de devoluciones: menos del 1%.
            </div>
          </div>
        </FadeIn>

        {/* FAQ */}
        <FadeIn delay={0.6} data-id="element-409">
          <div className="max-w-3xl mx-auto mt-12" data-id="element-410">
            <h3 className="text-2xl md:text-3xl font-bold text-white mb-8 text-center" data-id="element-411">
              ❓ LO QUE MÁS NOS PREGUNTAN
            </h3>
            <div className="space-y-4" role="list" data-id="element-412">
              {[{
              q: '¿Sirve si trabajo con sistemas que no son los que aparecen en el manual?',
              a: 'Sí. Los principios de medición, descuento e instalación aplican a todos los sistemas de mamparas de vidrio del mercado argentino. Las fórmulas son adaptables a cualquier marca o línea.'
            }, {
              q: '¿Cómo recibo el material?',
              a: 'Al completar el pago recibís un email con el link de descarga inmediata. En menos de 5 minutos tenés todo el sistema en tu celular o computadora.'
            }, {
              q: '¿Puedo imprimirlo?',
              a: 'Sí. Todo el sistema está diseñado para imprimir. Las planillas, checklists y tablas están optimizadas para formato A4 y para pegar en el taller.'
            }, {
              q: '¿Sirve si soy nuevo en la instalación de mamparas?',
              a: 'Sí. El sistema arranca desde el Módulo 1 con la anatomía completa de la mampara y va subiendo de nivel en cada módulo. No necesitás experiencia previa.'
            }, {
              q: '¿Tiene garantía real?',
              a: 'Sí. 7 días de garantía total. Si no es lo que esperabas, te devolvemos el 100% sin preguntas.'
            }].map((faq, i) => <div key={i} className="bg-surfaceLight border border-white/5 rounded-xl overflow-hidden" role="listitem" data-id="element-413">
                  <button onClick={() => setOpenFaq(openFaq === i ? null : i)} className="w-full px-6 py-4 text-left flex items-center justify-between focus-visible:outline-2 focus-visible:outline-offset-[-2px] focus-visible:outline-gold" aria-expanded={openFaq === i} aria-controls={`faq-answer-${i}`} data-id="element-414">
                    <span className="font-medium text-white pr-4" data-id="element-415">{faq.q}</span>
                    <ChevronDown className={`w-5 h-5 text-gray-400 transition-transform shrink-0 ${openFaq === i ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-416" />
                  </button>
                  {openFaq === i && <div id={`faq-answer-${i}`} className="px-6 pb-4 text-gray-400" role="region" aria-label={faq.q} data-id="element-417">
                      {faq.a}
                    </div>}
                </div>)}
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}